/**
 * Novedades por actualización. El aviso «Novedades» se abre una sola vez por entrada nueva
 * (se guarda en localStorage el `id` ya mostrado). Para anunciar una actualización, agrega una
 * entrada AL INICIO con un `id` nuevo (p. ej. la fecha) y sus puntos.
 */
export interface ReleaseItem {
  /** Nombre de ícono del panel (ver components/ui/Icon.tsx). */
  icon: "video" | "chart" | "eye" | "help" | "info" | "alert" | "photo" | "download" | "sliders";
  title: string;
  text: string;
}

export interface Release {
  id: string;
  date: string;
  title: string;
  items: ReleaseItem[];
}

export const RELEASES: Release[] = [
  {
    id: "2026-10-26-videos",
    date: "26 de octubre de 2026",
    title: "Videos, análisis en el tiempo y recorrido guiado",
    items: [
      {
        icon: "video",
        title: "Videos como estímulos",
        text: "En «Multimedia» ahora puedes subir videos (MP4, WebM o MOV, de 3 a 180 s) junto con tus imágenes, en el mismo estudio. Se convierten solos a MP4 H.264 de 30 fps y te avisa si algo se sale de lo recomendado.",
      },
      {
        icon: "chart",
        title: "Resultados de video",
        text: "Mapa de calor sincronizado con el video por ventanas de tiempo, curvas por grupo (mirada en un ROI o dispersión), ROIs con intervalo y la exportación windows.csv.",
      },
      {
        icon: "eye",
        title: "Validación con punto en movimiento",
        text: "Opcional en Configuración → Captura: la persona sigue un punto con la mirada y se mide su retraso real, para corregir la latencia de la webcam al analizar videos.",
      },
      {
        icon: "help",
        title: "Recorrido guiado",
        text: "El botón «Recorrido guiado» del menú explica paso a paso la pantalla en la que estés.",
      },
      {
        icon: "info",
        title: "Modo demo y seguridad",
        text: "La instalación puede funcionar como demostración (límites y aviso visibles). La contraseña del administrador ya no se cambia desde el panel, sino desde el servidor.",
      },
    ],
  },
];

export const LATEST_RELEASE_ID = RELEASES[0]!.id;
export const WHATS_NEW_STORAGE_KEY = "gazelab:whats-new-seen";
